import React from 'react';
import NoDataSection from '@components/report/no-data-section/NoDataSection';
import RecommendedAccountItem, {
	RecommendedAccountItemProps,
} from '@components/report/recommended-account-item/RecommendedAccountItem';
import SnapCarousel from '@shared/snap-carousel/SnapCarousel';
import { lackOfPermissionClass } from '@components/report/style.css';

export interface RecommendationProps {
	accounts?: RecommendedAccountItemProps[];
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const Recommendations = ({
	accounts = [],
	isLoading,
	isError,
	lackOfPermission,
}: RecommendationProps) => {
	const status = { isLoading, isError, lackOfPermission };
	const available = !isLoading && !isError && !lackOfPermission;

	accounts = available ? accounts : new Array(5).fill({});

	if (!available || (available && accounts.length > 0))
		return (
			<SnapCarousel
				className={lackOfPermission ? lackOfPermissionClass : ''}
				items={accounts.map((account, idx) => (
					<RecommendedAccountItem key={idx} idx={idx} {...account} {...status} />
				))}
			/>
		);
	else return <NoDataSection />;
};

export default Recommendations;
